import React from "react";
// import { Link } from "react-router-dom";
import db from "../../db/index.json";
import LabelTag from "../reusebale/label";
import ButtonTag from "../reusebale/button";
import ParagraphTag from '../reusebale/Paragraph'

const FormSection = () => {
  const { verification } = db;

  return (
    <form className="mt-8">
      <div className="w-full mt-3 flex flex-col lg:flex-row lg:justify-between">
        <div class="w-full lg:w-[49%]">
          <LabelTag name={verification.phoneLable} isStaric={false}/>
          <div className="w-full relative">
            <input
              type="text"
              placeholder="Enter your Phone Number.."
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
            <div className="absolute top-[6px] right-[2px]">
              <ButtonTag name={verification.verify} classes='text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white'/>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-[49%] mt-4 lg:mt-0">
          <LabelTag name={verification.otpLabel} isStaric={false}/>
          <div className="w-full relative">
            <input
              type="text"
              placeholder="Enter 4 digit OTP"
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
            <div className="absolute top-[6px] right-[2px]">
              <ButtonTag name={verification.otpSubmit} classes='text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white'/>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full mt-3 flex flex-col lg:flex-row lg:justify-between">
        <div class="w-full lg:w-[49%]">
          <LabelTag name={verification.emailLabel} isStaric={false}/>
          <div className="w-full relative">
            <input
              type="text"
              placeholder="Enter your email.."
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
            <div className="absolute top-[6px] right-[2px]">
              <ButtonTag name={verification.verify} classes='text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white'/>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-[49%] mt-4 lg:mt-0">
          <LabelTag name={verification.otpLabel} isStaric={false}/>
          <div className="w-full relative">
            <input
              type="text"
              placeholder="Enter 4 digit OTP"
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
            <div className="absolute top-[6px] right-[2px]">
              <ButtonTag name={verification.otpSubmit} classes='text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white'/>
            </div>
          </div>
        </div>
      </div>
      <ButtonTag name={verification.verify} classes='text-base bg-themeColor hover:bg-themeColor/90 mt-5 text-center text-white'/>
      <div className="w-full text-center pt-5">
        <ParagraphTag content={verification.msgOtp} classes='text-[#686868] font-popinsRegular text-sm'/>
        <ParagraphTag content={verification.resend} classes='text-themeColor pb-5 lg:pb-0 font-popinsRegular text-sm cursor-pointer'/>
      </div>
    </form>
  );
};

export default FormSection;
